import { theme } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

interface Props {
  color?: string;
}

const Bullet = styled.li<Props>`
  color: ${props => (props.color ? theme.colors[props.color as keyof typeof theme.colors] : theme.colors.bmtGrey90)};
`;

export default Bullet;
